import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { Media } from '$partials/media';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').MediaCardsBlock}
 */
const MediaCards = ({
    backgroundColor,
    cards,
    id,
    text,
    title
}) => {
    const { page } = usePage();

    const bgColor = `bg-surface-panel-${backgroundColor}`;

    return (
        <section className={`col-wrapper-breakout ${bgColor} rounded-lg pt-24 pb-16`}>
            <h2 className='col-padding type-style-sans-h1 w-full sm:w-6/12 md:w-7/12'>
                {title}
            </h2>

            {text && (
                <p className='col-padding type-style-sans-h3 mt-8 w-full sm:w-6/12 md:w-5/12'>
                    {text}
                </p>
            )}

            <div className='col-padding mt-40 sm:grid-cols-3 gap-8 md:gap-16 grid'>
                {cards.map((card) => {
                    return (
                        <div
                            className='bg-surface-raised p-16 rounded-lg flex flex-col'
                            key={card.id}>
                            <figure className='rounded-lg overflow-hidden'>
                                <Media {
                                    ...{
                                        ...card.media,
                                        ...(card.media.image ? {
                                            image: {
                                                ...card.media?.image,
                                                containerClassName: 'rounded-lg overflow-hidden pointer-events-none select-none'
                                            }
                                        } : {}),
                                        ...(card.media.videoEmbed ? {
                                            videoEmbed: {
                                                ...card.media.videoEmbed,
                                                poster: card.media?.videoEmbed?.poster || card.media?.videoEmbed?.embed?.thumbnailUrl
                                            }
                                        } : {} )
                                    }
                                }/>
                            </figure>

                            <div className='flex flex-col mt-16 md:mt-24 flex-grow justify-between'>
                                <div>
                                    <p className='type-style-sans-h3-med'>
                                        {card.title}
                                    </p>

                                    {card.text && (
                                        <p className='type-style-sans-body mt-8'>
                                            {card.text}
                                        </p>
                                    )}
                                </div>

                                {card.ctaLabel && (
                                    <a
                                        className='underline mt-12 type-style-sans-body'
                                        data-analytics-action='click'
                                        data-analytics-context={title}
                                        data-analytics-destination={formatLinkBlockToUrl(card.ctaLink)}
                                        data-analytics-id={`${page?.id}_${id}_media_cards_cta`}
                                        data-analytics-label={card.ctaLabel}
                                        data-analytics-location='modules'
                                        data-analytics-module='media_cards_cta'
                                        href={formatLinkBlockToUrl(card.ctaLink)}>
                                        {card.ctaLabel}
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default MediaCards;
